import React, { useState, useEffect, useContext } from "react";
import { AuthContext, showAlert } from "../util/api";

import api from "../util/api";

import { useNavigate } from "react-router-dom";
import Navbar from "../header";
import Footer from "../footer";

export default function NotificationPage() {
    const [expanded, setExpanded] = useState({});
    const { token, User, admin } = useContext(AuthContext);
    const [notifications, setNotification] = useState([]);
    const [loading, setLoading] = useState(false);
    const router = useNavigate();

    async function getNotification() {
        setLoading(true);

        try {

            let notiLink = "";

            //notification  link  
            if (admin != null) {
                notiLink = `/notifications?user_id=${User["id"]}&admin=yes`;
               


            } else {

                notiLink = `/notifications?user_id=${User["id"]}`


            }
            const response = await api.get(notiLink);
            if (response.data.status === "successful") {
                const depositsArray = Object.values(response.data.notifications.data);
                const deposits = Array.isArray(depositsArray) ? depositsArray : [];
                setNotification(deposits);
            } else {
                showAlert("error", "error", response.data.message);
            }
        } catch (error) {
            showAlert("error", "error", "Error fetching notifications.");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (token && token !== "undefined" && token !== "") {

            getNotification();
        } else {
            router("/login");
        }
    }, []);

    const toggleExpand = (id) => {
        setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    return (
        <>
            <Navbar menuColor="red" />

            <div  ></div>

            <div style={{
                padding: "40px 20px",
                fontFamily: "Segoe UI, sans-serif",
                backgroundColor: "#f0f2f5",
                minHeight: "100vh"
            }}>
                <div style={{
                    maxWidth: "800px",
                    margin: "0 auto",
                    backgroundColor: "#fff",
                    borderRadius: "16px",
                    padding: "30px",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.1)"
                }}>
                    <h2 style={{
                        textAlign: "center",
                        color: "#2c3e50",
                        fontSize: "32px",
                        marginBottom: "30px",
                        borderBottom: "2px solid #eee",
                        paddingBottom: "10px"
                    }}>🔔 Notifications</h2>

                    <ul style={{ listStyle: "none", padding: 0 }}>
                        {notifications.length === 0 && (
                            <p style={{
                                textAlign: "center",
                                fontStyle: "italic",
                                color: "#777"
                            }}>No notifications yet.</p>
                        )}

                        {notifications.map((notification) => {
                            const isExpanded = expanded[notification.id];
                            const shouldTruncate = notification.message.length > 400 && !isExpanded;

                            return (
                                <li key={notification.id} style={{
                                    marginBottom: "20px",
                                    padding: "20px",
                                    borderRadius: "12px",
                                    background: "linear-gradient(135deg, #ffffff, #f7f9fb)",
                                    boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                                    transition: "transform 0.2s ease-in-out"
                                }}>
                                    <h3 style={{
                                        fontSize: "20px",
                                        color: "#34495e",
                                        marginBottom: "10px"
                                    }}>{notification.subject}</h3>
                                    <p
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "1.6",
                                            color: "#555"
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: shouldTruncate
                                                ? `${notification.message.substring(0, 400)}...`
                                                : notification.message
                                        }}
                                    />
                                    {notification.message.length > 400 && (
                                        <button
                                            onClick={() => toggleExpand(notification.id)}
                                            style={{
                                                marginTop: "15px",
                                                padding: "8px 16px",
                                                backgroundColor: "#2980b9",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "6px",
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                                transition: "background-color 0.3s ease"
                                            }}
                                        >
                                            {isExpanded ? "Show Less" : "Read More"}
                                        </button>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>

            <Footer />

        </>
    );
}
